import * as Sentry from "@sentry/react";

const getEnv = () => {
  const DEV_ENVS = ["localhost", "dev"];
  if (DEV_ENVS.some((env) => window.location.hostname.includes(env))) {
    return "dev";
  }
  if (window.location.hostname.includes("demo")) {
    return "demo";
  }
  return "prod";
};

Sentry.init({
  dsn: "https://21415a986a85455275b9541c5b735260@o4508123315503104.ingest.us.sentry.io/4508123317993472",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:*.fanrally.com/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: getEnv(),
});
